import { api } from 'API/axios';
import {
  IExpenseRefundFilters,
  IExpenseRefundItem,
  IExpenseRefundListResponse,
} from 'Interfaces/expenseRefundList';

const baseURL = '/ExpenseRefundList';

const buildParams = (filters: IExpenseRefundFilters) => {
  const params: Record<string, string | number | boolean | undefined> = {
    fromDate: filters.fromDate?.toISOString(),
    toDate: filters.toDate?.toISOString(),
    caseNumber: filters.caseNumber?.trim() || undefined,
    invoiceNumber: filters.invoiceNumber?.trim() || undefined,
    supplierId: filters.supplierId?.trim() || undefined,
    supplierName: filters.supplierName?.trim() || undefined,
    catalogNumber: filters.catalogNumber?.trim() || undefined,
  };

  if (filters.page !== undefined) params.page = filters.page;
  if (filters.pageSize !== undefined) params.pageSize = filters.pageSize;

  return params;
};

export const getExpenseRefundList = async (filters: IExpenseRefundFilters) => {
  const result = await api.get<IExpenseRefundListResponse>(baseURL, {
    params: buildParams(filters),
  });
  if (result) return result.data;
};

export const getExpenseRefundListExport = async (
  filters: IExpenseRefundFilters,
): Promise<IExpenseRefundItem[]> => {
  const result = await api.get<IExpenseRefundItem[]>(`${baseURL}/export`, {
    params: buildParams(filters),
  });
  return result.data;
};
